import {useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {selectEnvelopeStickers} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {CanvasStickers} from '~/common/canvas/CanvasStickers';
import {EventCreateStampContext} from '~/common/fabric/CreateDesign/components/Stamp/EventCreateStampContext';

export const StickersCanvas = ({className}) => {
  const {setCanvas} = useContext(EventCreateStampContext);
  const envelopeStickers = useSelector(selectEnvelopeStickers);
  const dispatch = useDispatch();

  const onChangeHandler = (envelopeStickers) => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {
        envelopeStickers,
      },
    });
  };

  return (
    <div className={className}>
      <CanvasStickers
        configJson={envelopeStickers}
        onChange={onChangeHandler}
        setCanvas={setCanvas}
      />
    </div>
  );
};
